import { X } from 'lucide-react'
import * as React from 'react'

import UserSearch from '@/components/chat/user-search'
import { Button } from '@/components/ui/button'

import type { UserAuth } from '@/types/user.type'

interface UserSearchDialogProps {
  isOpen: boolean
  onClose: () => void
  onUserSelect: (user: { id: number; firstName: string; lastName: string; email: string; avatar?: string }) => void
  authUser: UserAuth | null
}

export const UserSearchDialog: React.FC<UserSearchDialogProps> = ({ isOpen, onClose, onUserSelect, authUser }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white rounded-lg shadow-xl">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Search Users</h3>
            <Button variant="ghost" size="sm" onClick={onClose} className="p-1">
              <X className="h-4 w-4" />
            </Button>
          </div>
          <UserSearch
            onUserSelect={onUserSelect}
            placeholder="Search users to chat with..."
            excludeUserIds={authUser?.id ? [authUser.id] : []}
          />
        </div>
      </div>
    </div>
  )
}
